module.exports = __webpack_public_path__ + "img/portugal-flag.36a2c447.png";